import React, { useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import {
  addIframeAllowAutoplay,
  addAutoplayToUrl,
  extractYoutubeVideoID,
  isYoutubeEmbedLink,
  generateThumbnailImage,
} from 'utils/youtube';
import youtubeLazyLoadStyles from 'utils/youtube.css';
import YoutubeLazyLoadEmbedStyles from 'components/youtube/youtubeLazyLoadEmbedsStyles';
import { trackPageEvent } from 'utils/tracking';

import styles from './featuredVideo.css';

// 16:9 aspect ratio
const height = '360';
const width = '640';

const FeaturedVideo = ({ title, url, onVideoClicked }) => {
  const isYoutube = isYoutubeEmbedLink(url);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  // We only know how to lazy load youtube embeds for now
  const [shouldLoad, setShouldLoad] = useState(!isYoutube);
  const videoWrapperClasses = classNames(
    styles.featuredVideoWrapper,
    { [styles.loadingVideo]: isLoading && !isError },
  );

  if (!shouldLoad && isYoutube) {
    const thumbnail = generateThumbnailImage(extractYoutubeVideoID(url));
    // Given we have a button lower below, the onClick for accessibility should bubble from there instead
    return (<div className={styles.featuredVideoWrapper}>
      <YoutubeLazyLoadEmbedStyles />
      <div
        className={classNames([youtubeLazyLoadStyles.lazyLoadEmbed, styles.featuredVideo])}
      >
        {/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
        <div
          className={youtubeLazyLoadStyles.hoverOverlay}
          onClick={() => {
            onVideoClicked({ url });
            setShouldLoad(true);
          }}
        >
          {/* eslint-enable */}
          <img alt="video thumbnail" className={youtubeLazyLoadStyles.thumbnail} src={thumbnail} />
          <button className={youtubeLazyLoadStyles.playButton}>
            <span className={youtubeLazyLoadStyles.visuallyHidden}>Play</span>
          </button>
        </div>
      </div>
    </div>);
  }

  return (
    <div className={videoWrapperClasses}>
      <iframe
        allow={addIframeAllowAutoplay('')}
        className={styles.featuredVideo}
        onError={() => setIsError(true)}
        onLoad={() => setIsLoading(false)}
        src={isYoutube ? addAutoplayToUrl(url) : url}
        title={title}
        height={height}
        width={width}
      />
    </div>
  );
};

FeaturedVideo.propTypes = {
  onVideoClicked: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

const wrapWithStyles = withStyles(styles);
export default wrapWithStyles(FeaturedVideo);
